<template>
  <div class="section is-anura">
    <div class="container">
      <div class="anura-header clearfix">
        <div class="search" />
        <div class="anura-tools">
          <div id="anura-basket" class="line-button-wrapper" title="Basket">
            <a class="button is-primary"
              >{{ $texts('filesInBasket', 'Files in basket: ') }}&nbsp;<span
                >0</span
              ></a
            >
          </div>
        </div>
      </div>
      <div class="anura-container clearfix">
        <div class="anura-menu">
          <div class="anura-heading" />
          <div id="anura-tree" class="anura-tree" />
        </div>
        <section class="anura-main">
          <div id="anura-gallery" />
        </section>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import jQuery from 'jquery'
import 'imagesloaded/imagesloaded.pkgd'
import initAnura from './../../helpers/initAnura'
import './../../assets/css/jquery.anura.basket-synergy.css'
import './../../assets/css/jquery.anura.tree.css'
import './../../assets/css/colorbox.css'
import './../../assets/css/anura.scss'

// @ts-ignore
window.jQuery = jQuery
// @ts-ignore
window.$ = jQuery

const language = useCurrentLanguage()

await useScript('/_anura/assets/js/jquery.colorbox-min.js').load()
await useScript('/_anura/assets/js/jquery.anura.util.js').load()
await useScript('/_anura/assets/js/jquery.anura.basket-synergy.js').load()
await useScript('/_anura/assets/js/jquery.anura.details.js').load()
await useScript('/_anura/assets/js/jquery.anura.gallery.js').load()
await useScript('/_anura/assets/js/jquery.anura.tree.js').load()
await useScript('/_anura/assets/js/jquery.anura.search.js').load()

onMounted(() => {
  initAnura(language.value)
})
</script>

<style lang="postcss">
.is-anura {
  background: gainsboro;
  min-height: 80rem;
}

.anura-container {
  @screen tablet {
    @apply grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr 3fr;
  }
}

.anura-basket-popup,
.anura-basket-toc,
.anura-basket-tc-confirm,
.anura-basket-assets,
.anura-basket-dlf-select-active,
.anura-basket-dlf-select-options {
  @apply bg-background;
}

.anura-basket-footer,
.anura-basket-asset,
.anura-basket-popup-titlebar {
  @apply bg-scheme-main-bis;
}

.anura-basket-popup-titlebar,
.anura-basket-popup-title {
  @apply text-scheme-invert-ter;
}

.anura-search-text {
  @apply font-sans;
}
</style>
